import React, { Component, Fragment } from 'react';
import { translate } from 'react-i18next';

import LogoGobierno from 'static/img/gobierno_color_transparente_white.png';

import './Header.css';

declare var CONFIGURATIONS;

class Header extends Component {

  goHome = () => {
    const url = `${window.location.href.split('/catalogocartoteca/')[0]}/catalogocartoteca/home`;
    window.location.href = url;
  }

  render() {
    return (<Fragment>
      <header className='h-desktop'>
        <div className="logo-gobierno">
          <img src={LogoGobierno} alt='Logo del gobierno'/>
        </div>
        <div className='visor-title'>
          <label className='title' onClick={this.goHome}>Cartoteca digital de Aragón</label>
        </div>
        <div className="logo-instituto">
        </div>
      </header>
    </Fragment>);
  }
}

export default translate()(Header);
